import React, { FC, useEffect, useState } from 'react';

import SPageLoaderWithTimer from 'Components/structural/SPageLoaderWithTimer/SPageLoaderWithTimer';
import { useAppDispatch } from 'Libs/redux/store';
import { useTypedSelector } from 'Libs/redux/utils';
import { activityActions } from 'Store/entities/activity/activity.slice';
import { fetchBreakingNewsById } from 'Store/entities/activity/activity.thunks';
import { BreakingNews } from 'Store/entities/activity/activity.type';

import styles from '../BreakingNews.style';
import { inferIdFromPath, redirectToActivityList } from '../routing.utils';

export const withFetchBreakingNewsHoc = (Component: FC<{ breakingNews: BreakingNews }>) => {
  return function BreakingNewsPage() {
    const dispatch = useAppDispatch();

    const [breakingNewsId] = useState(() => inferIdFromPath());
    const { loading, breakingNews } = useTypedSelector((state) => state.entities.activity.edition);

    const showLoader = !breakingNews || loading;

    useEffect(() => {
      if (breakingNewsId && !breakingNews) {
        dispatch(fetchBreakingNewsById(breakingNewsId));
      }

      return () => {
        dispatch(activityActions.resetEdition());
      };
    }, []);

    if (!breakingNewsId) {
      redirectToActivityList();
      return null;
    }

    if (showLoader) {
      return (
        <div style={styles.container}>
          <SPageLoaderWithTimer isLoading />
        </div>
      );
    }

    return <Component breakingNews={breakingNews} />;
  };
};
